/* eslint-disable @typescript-eslint/no-magic-numbers */

import { ChangeDetectionStrategy, Component, input, OnChanges, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { FfdNoteItem } from '@libs/ffd-notes';
import { FfdNoteHeaderComponent } from '../ffd-note-header';

@Component({
  selector: 'lib-ffd-note',
  imports: [CommonModule, TranslateModule, FfdNoteHeaderComponent, SvgIconComponent],
  templateUrl: './ffd-note.component.html',
  styleUrl: './ffd-note.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNoteComponent implements OnChanges {
  public note = input.required<FfdNoteItem>();
  public searchTerm = input<string | null>(null);
  public readonly inEditMode = input(false);
  public isNoteSaving = input<boolean>(false);
  public isNoteSaved = input<boolean>(false);

  public readonly editNote = output<void>();
  public readonly deleteNote = output<string>();
  public cancelEditMode = output();
  public readonly noteSave = output<FfdNoteItem>();

  protected noteText: string = '';

  public ngOnChanges(): void {
    this.updateCurrentNoteText();
    if (this.searchTerm()) {
      const re = new RegExp(`(${this.searchTerm()})`, 'gi');
      const highlightedHtml = `<span class="bg-states-orange text-text-white">$1</span>`;
      this.noteText = this.noteText.replace(re, highlightedHtml);
    }
  }

  private updateCurrentNoteText(): void {
    this.noteText = this.note().content && this.note().content.endsWith('\n') ? this.note().content : `${this.note().content || ''}\n`;
  }

  protected toggleEditMode(event?: Event): void {
    event?.stopPropagation();
    if (this.inEditMode()) {
      this.cancelEditMode.emit();
    } else {
      this.editNote.emit();
    }
  }

  protected onDeleteNoteClick(): void {
    this.deleteNote.emit(this.note().id);
  }

  protected onNoteSave(saveData: FfdNoteItem): void {
    this.noteSave.emit(saveData);
  }
}
